<template>
  <div class="imgDiv" id="imgDiv">
    <img src="@/assets/images/ezw.png" width="1060" height="647" id="imgPainter" />
    <div class="marker" v-for="(item, key) in  data.mapList" :key="key" :style="{top: item.ordinate+'px', 'left': item.abscissa+'px'}" @click="handlerDetail(item,key)">
      <div :class="data.indexDB==key ? 'abs' : 'zb'"> </div>
      <div :class="data.indexDB==key ? 'ponints' : 'ponint'">{{data.indexDB==key ? item.point : ''}}</div>
    </div>
  </div>

</template>
  
  <script setup>
import { ref, onMounted, reactive, defineEmits } from "vue";

const data = reactive({
  indexDB: 0,
  mapList: [
    { "id": 1, "name": "童游", "abscissa": 703, "ordinate": 380, "point": "童游派出所" },
    { "id": 2, "name": "将口", "abscissa": 631, "ordinate": 274, "point": "将口派出所" },
    { "id": 3, "name": "童游", "abscissa": 570, "ordinate": 440, "point": "电力大厦（国家电网自助服务厅）" },
    { "id": 4, "name": "南平市", "abscissa": 669, "ordinate": 377, "point": "万达广场" },
    { "id": 5, "name": "童游", "abscissa": 722, "ordinate": 350, "point": "建阳区市立医院住院部" },
    { "id": 6, "name": "水吉", "abscissa": 800, "ordinate": 300, "point": "水吉行政服务中心" },
    { "id": 7, "name": "麻沙", "abscissa": 365, "ordinate": 338, "point": "麻沙便民服务中心" },
    { "id": 8, "name": "童游", "abscissa": 656, "ordinate": 377, "point": "南平佰翔大酒店" },
    { "id": 9, "name": "莒口镇", "abscissa": 488, "ordinate": 388, "point": "莒口镇便民服务中心" },
    { "id": 10, "name": "小湖镇", "abscissa": 800, "ordinate": 423, "point": "小湖镇便民服务中心农产品市场" },
    { "id": 11, "name": "黄坑镇", "abscissa": 185, "ordinate": 138, "point": "黄坑镇便民服务中心" },
    { "id": 12, "name": "崇雒乡", "abscissa": 713, "ordinate": 247, "point": "崇雒乡便民服务中心" },
    { "id": 13, "name": "回龙乡", "abscissa": 920, "ordinate": 250, "point": "回龙乡便民服务中心" },
    { "id": 14, "name": "", "abscissa": 982, "ordinate": 268, "point": "漳墩镇便民服务中心" },
    { "id": 15, "name": "崇阳", "abscissa": 628, "ordinate": 355, "point": "温德姆酒店" },
    { "id": 16, "name": "童游", "abscissa": 600, "ordinate": 420, "point": "武夷悦酒店" },
    { "id": 17, "name": "童游", "abscissa": 645, "ordinate": 452, "point": "南平市第二医院" },
    { "id": 18, "name": "童游", "abscissa": 586, "ordinate": 400, "point": "建发悦城3号门" },
    { "id": 19, "name": "童游", "abscissa": 628, "ordinate": 425, "point": "维也纳国际酒店" },
    { "id": 20, "name": "童游", "abscissa": 592, "ordinate": 350, "point": "南平市行政服务中心（24小时区）" },
    { "id": 21, "name": "童游", "abscissa": 628, "ordinate": 465, "point": "建阳城关派出所" },
    { "id": 22, "name": "童游", "abscissa": 670, "ordinate": 400, "point": "御景湾国际大酒店酒店" },
    { "id": 23, "name": "童游", "abscissa": 583, "ordinate": 352, "point": "南平市行政服务中心（大厅）" },
    { "id": 24, "name": "童游", "abscissa": 606, "ordinate": 352, "point": "南平市人民政府2号楼" },
    { "id": 25, "name": "童游", "abscissa": 626, "ordinate": 290, "point": "南平市动车站(售票厅)" },
  ]
})

const emits = defineEmits(["clickFather"]);
const handlerDetail = (item, key) => {
  console.log(item, key)
  emits("clickFather", item.point);
  data.indexDB = key;
}
  </script>
  
  <style lang="scss" scoped>
.imgDiv {
  position: relative;
  height: 100%;
  width: 100%;
  height: 694px;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2)
    ),
    url("@/assets/images/map.png") no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  .marker {
    position: absolute;
    // border-radius: 50%;
    // z-index: 999;
    cursor: pointer;
    // color: yellow;
    .zb {
      position: absolute;
      left: 0;
      top: 0;
      width: 26px;
      height: 28px;
      // background-color: red;
      // text-align: center;
      // line-height: 20px;
      background: url("@/assets/images/address.png") no-repeat center;
      background-size: 100% 100%;
    }
    .abs {
      position: absolute;
      left: 0;
      top: 0;
      width: 26px;
      height: 28px;
      // background-color: red;
      // text-align: center;
      // line-height: 20px;
      background: url("@/assets/images/adr.png") no-repeat center;
      background-size: 100% 100%;
      z-index: 99;
    }
    .ponint {
      // width: 300px;
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -20px;
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: 0em;
      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #454b6a;
      text-shadow: 0px 3.52px 8.79px rgba(0, 0, 0, 0.3);
    }
    .ponints {
      display: inline-block;
      white-space: nowrap;
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translateX(-46%);
      top: -20px;
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: 0em;
      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #1c599d;
      text-shadow: 0px 3.52px 8.79px rgba(0, 0, 0, 0.3);
      z-index: 999;
    }
  }

  .marker:hover .ponint {
    display: block;
  }
}
</style>